import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from '../PA.UIM.Core/PA.UIM.Core.IF.Search'
import { PAEnvironment } from '../PA.Core/PAEnvironment'
import { SearchUtils } from '../PA.UIM.Core/SearchUtils'
import { PASearch } from '../PA.Core/PASearch'

const vUI_DeconstructedDataMart_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_DATAMART_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'DataMart WB Id',
            columnResourceName: 'colDataMartWBId',
            alignment: HorizAlignment.Center
        },
        domainOptions: {}
    },
    DM_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Deconstructed Datamart ID',
            columnResourceName: 'colDataMartId',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 50 }
    },
    DM_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Deconstructed Datamart Name',
            columnResourceName: 'colDataMartName',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    DM_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Build Type',
            columnResourceName: 'colDataMartType',
            alignment: HorizAlignment.Left
        },
        domainOptions: { maxLength: 256 }
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: 'MM/dd/yyyy'
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: 'MM/dd/yyyy'
        },
        domainOptions: {}
    }
}

const DeconstructedDataMartSearchProviderBasic: ISearchProvider = {
    keyFields: { id: 'WB_DATAMART_ID', id_ui: 'DM_ID', name: 'DM_NAME' },

    searchProviderFields: vUI_DeconstructedDataMart_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(
                searchOptions,
                'vUI_DeconstructedDataMart_Search',
                this.searchProviderFields,
                []
            )

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }
}

const DeconstructedDataMartSearchProfileByName: ISearchProfile = {
    profileId: 'default',
    profileName: 'Search by Id, Name',
    renderOptions: { ui5ResourceId: 'DeconstructedDataMartSearchProfileByName' },

    profileFilter: [
        { profileFilterName: 'Deconstructed DataMart Id', searchProviderFieldId: 'DM_ID', renderOptions: {} },
        { profileFilterName: 'Deconstructed DataMart Name', searchProviderFieldId: 'DM_NAME', renderOptions: {} }
    ], // ISearchFields
    profileDisplayFields: ['DM_ID', 'DM_NAME', 'DM_TYPE', 'CREATED_DTTS', 'MODIFIED_DTTS'], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: DeconstructedDataMartSearchProviderBasic,
    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: 'default', //string;
    profileSorts: [] //ISearchSort[];
}

const DeconstructedDataMartSearch: ISearch = {
    searchName: 'Find Deconstructed DataMart',
    renderOptions: { ui5ResourceId: 'DeconstructedDataMartSearch' },
    searchProfileIdDefault: 'default',
    searchProfiles: [DeconstructedDataMartSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch(
    'DeconstructedDataMartBO',
    'DeconstructedDataMart',
    DeconstructedDataMartSearch,
    'DeconstructedDataMart Search'
)

export { DeconstructedDataMartSearch }
